import React, { useEffect, useState } from "react";
// import RoomBookingTable from "./Components/RoomBookingTable";
// import { useDispatch} from "react-redux"
import { useLocation, useNavigate, useParams } from "react-router-dom";
import RestaurantCategoryTable from "./Components/RestaurantCateogoryTable";
import AddRestaurantCategory from "./Components/AddRestaurantCategory";
import RestaurantVariantTable from "./Components/RestaurantVariantTable";
import AddRestaurantVariant from "./Components/AddRestaurantVariant";
import { hasAddAccess } from "../../../../Common/CheckAccess";

const ReservationVariantList = () => {
  // const dispatch = useDispatch()
  const navigate = useNavigate();
  const location = useLocation();
  const { subCategoryId } = useParams()
  const [selectedVariant,setSelectedVariant] = useState(null)

 const [permissions, setPermissions] = useState([]);
    
      const existingPermissions = localStorage.getItem("checkPermission");
    
      useEffect(() => {
        if (existingPermissions != undefined) {
          const parsedData = JSON.parse(existingPermissions);
          setPermissions(parsedData);
        }
      }, [existingPermissions]);
  return (
    <>
      <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
        <div className="row g-3">
          <div className="col-sm-12">
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <h3 className="fw-bold mb-0">Variant List</h3>
              <div className="col-auto d-flex w-sm-100 align-content-center gap-3">
              <button
                type="button"
                className="btn btn-secondary"
                style={{ maxHeight: "40px" }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                Back
              </button>
                {hasAddAccess(permissions, "restaurant") &&<button
                  type="button"
                  className="btn btn-dark"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#add-varient"
                  aria-controls="add-varient"
                  onClick={() => setSelectedVariant(null)}
                >
                  Add Variant
                </button>}
              </div>
            </div>
          </div>
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-body ">
                <RestaurantVariantTable
                  subCategoryId={subCategoryId}
                  setSelectedVariant={setSelectedVariant}
                  // data ={roomReservation.data}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddRestaurantVariant
        setSelectedVariant={setSelectedVariant}
        selectedVariant={selectedVariant}
      />
    </>
  );
};
export default ReservationVariantList;